import i18next from "i18next";
import languagedetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translations
import translationEN from "./locales/en.json";
import translationAR from "./locales/ar.json";

// Force Arabic for Libya portal ONLY on first visit
const hostname = window.location.hostname;
const isLibyaPortal = hostname.includes("libyad") || hostname.includes("lebara") || hostname.includes("localhost") || hostname.includes("gamerclub.ly");
const isFirstVisit = !localStorage.getItem("libya_lang_initialized");

if (isLibyaPortal && isFirstVisit) {
  localStorage.setItem("i18nextLng", "ar");
  localStorage.setItem("libya_lang_initialized", "true");
}

// Force Arabic for Aciq portal on first visit (before browser detector runs)
const isAciqPortal = hostname.includes("aciq");
const isAciqFirstVisit = !localStorage.getItem("aciq_lang_initialized");

if (isAciqPortal && isAciqFirstVisit) {
  localStorage.setItem("i18nextLng", "ar");
  localStorage.setItem("aciq_lang_initialized", "true");
}

// Force English for MTN South Africa portal on first visit
const isMtnzaPortal = hostname.includes("mtnza");
const isMtnzaFirstVisit = !localStorage.getItem("mtnza_lang_initialized");

if (isMtnzaPortal && isMtnzaFirstVisit) {
  localStorage.setItem("i18nextLng", "en");
  localStorage.setItem("mtnza_lang_initialized", "true");
}

i18next
  .use(languagedetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "ar",
    returnObjects: true,
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR },
    },
    interpolation: {
      escapeValue: false, // not needed for React as it escapes by default
    },
  });
